import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { loadArea } from "../../../store/area/areaActions";
import ActionMenu from "../../actionmenu/Actionmenu";
import BreadcrumbIndex from "../../breadcrumb/BreadcrumbIndex";
import AreaListTable from "./AreaList";
import { getHolidays } from "../../../util/host";

export default function CityIndex() {
  const areaList = useSelector((state) => state.area.areaList);
  const deliveryList = useSelector((state) => state.delivery.deliveryList);
  const dispatch = useDispatch();

  const country = localStorage.getItem("country");
 
  const province = localStorage.getItem("province");
  const city = localStorage.getItem("city");

  const breadcrumb = [
    { title: "Home", url: "/mapper/country" },
    { title: country, url: "/mapper/province" },
    { title: province, url: "/mapper/city" },
    { title: city, url: "/mapper/area" },
  ];

  localStorage.setItem("breadcrumb", JSON.stringify(breadcrumb));

  useEffect(() => {
    const country = localStorage.getItem("country");
    const provinceId = localStorage.getItem("provinceId");
    const cityId = localStorage.getItem("cityId");
    dispatch(loadArea(country, provinceId, cityId));
  }, [dispatch]);

  return (
    <div>
      <BreadcrumbIndex />
      <ActionMenu />
      <AreaListTable tabaledata={areaList} holidays={getHolidays()} deliveryList={deliveryList} />
    </div>
  );
}
